import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield } from 'lucide-react';

const VehicleCard = ({ imageSrc, title }) => (
  <div className="group relative overflow-hidden rounded-xl">
    <img 
      src={imageSrc} 
      alt={title}
      className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-500"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
      <h3 className="text-white text-xl font-semibold p-6">{title}</h3>
    </div>
  </div>
);

const Landing = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Navigation */}
      <nav className="px-6 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <Shield className="w-8 h-8 text-primary-600" />
            <span className="text-xl font-bold text-gray-900">SureDrive</span>
          </div>
          <Link
            to="/login"
            className="btn btn-primary"
          >
            Sign In
            <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-6 pt-12 pb-24">
        <div className="text-center mb-16">
          <h1 className="text-6xl font-bold text-gray-900 mb-6">
            Protect Your
            <span className="text-primary-600"> Journey</span>
          </h1>
          <Link
            to="/login"
            className="btn btn-primary text-lg px-8 py-3"
          >
            Get Started
            <ArrowRight className="w-5 h-5 ml-2" />
          </Link>
        </div>

        {/* Vehicle Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <VehicleCard
            imageSrc="https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80"
            title="Cars & SUVs"
          />
          <VehicleCard
            imageSrc="https://images.unsplash.com/photo-1558981359-219d6364c9c8?auto=format&fit=crop&w=800&q=80"
            title="Motorcycles"
          />
          <VehicleCard
            imageSrc="https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=800&q=80"
            title="Commercial Vehicles"
          />
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto mt-24 text-center">
          <div>
            <div className="text-4xl font-bold text-primary-600 mb-2">15k+</div>
            <div className="text-gray-600">Vehicles Protected</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-primary-600 mb-2">99%</div>
            <div className="text-gray-600">Claims Approved</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-primary-600 mb-2">24/7</div>
            <div className="text-gray-600">Support</div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-8 text-center">
          <p className="text-gray-600">
            © {new Date().getFullYear()} SureDrive. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Landing;